// extracted by mini-css-extract-plugin
module.exports = {"list":"TimesList_list__TGd-c","day":"TimesList_day__lgIsD","bold":"TimesList_bold__tjr2l"};